export interface Props {
    text: string;
    highlight: string;
}

/**
 * Highlights given substring in a string. Used to highlight search results matching parts.
 */
export const HighlightedText: React.FC<Props> = ({text, highlight}) => {
    if (highlight === "") {
        return text;
    } else {
        const highlightedParts = text.split(new RegExp(`(${highlight})`, "gi"));
        return (
            <span>
                {highlightedParts.map((part, i) => (
                    <span
                        key={i}
                        style={
                            part.toLowerCase() === highlight.toLowerCase()
                                ? {fontWeight: "bold", background: "#FED976"}
                                : {}
                        }
                    >
                        {part}
                    </span>
                ))}
            </span>
        );
    }
};
